import React, { useLayoutEffect, useState } from "react";
import { Layout, Card, Table, Input, Space, Button, Popconfirm } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { getAPI, postAPI, displayMessage } from "../../utils/common";
import {
  ALL_DISCOUNT_COUPON,
  DELETE_DISCOUNT_COUPON,
} from "../../constants/api";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { useNavigate } from "react-router-dom";

function DiscountCouponTable() {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getList = () => {
    setLoading(true);
    getAPI(
      ALL_DISCOUNT_COUPON,
      (data) => {
        if (data.status === true) {
          const formattedData = data.data.map((row, index) => ({
            key: index,
            ID: index + 1,
            Name: row.title,
            Code: row.discount_code,
            DiscountType: row.discount_type,
            Value: row.discount_value,
            Action: (
              <Space>
                <Button
                  onClick={() =>
                    navigate("/master/discount-coupon/edit/" + row.id)
                  }
                >
                  Edit
                </Button>
                <Popconfirm
                  title="Delete the coupon"
                  description="Are you sure to delete?"
                  onConfirm={() => deleteData(row.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button danger>Delete</Button>
                </Popconfirm>
              </Space>
            ),
          }));
          setState(formattedData);
          setFilteredState(formattedData);
          setLoading(false);
        } else {
          setState([]);
          setFilteredState([]);
          setLoading(false);
        }
      },
      () => {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    );
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter((data) =>
      data.Name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const deleteData = (id) => {
    setLoading(true);
    postAPI(
      DELETE_DISCOUNT_COUPON,
      { id },
      (data) => {
        if (data.status === true) {
          displayMessage(SUCCESS_MESSAGE, data.message);
          getList();
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
        setLoading(false);
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
        setLoading(false);
      }
    );
  };

  const columns = [
    { title: "Sno", dataIndex: "ID", width: 50 },
    { title: "Name", dataIndex: "Name", width: 150 },
    { title: "Code", dataIndex: "Code", width: 100 },
    { title: "Discount Type", dataIndex: "DiscountType", width: 100 },
    { title: "Value", dataIndex: "Value", width: 100 },
    { title: "Action", dataIndex: "Action", width: 150 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Manage Discount Coupons"
          extra={
            <Space>
              <Input
                placeholder="Search by Name"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              <Button onClick={() => navigate("/master/discount-coupon/add")}>
                Add <PlusOutlined />
              </Button>
            </Space>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default DiscountCouponTable;
